/* 魏延（字文長） */
import { defineHero, U, S } from '../define.ts';

export default defineHero({
  id: 'weiyan', name: '魏延', sub: '字文長', faction: 'shu', role: '戰士', weapon: 'axe',
  look: { eye: 'fierce', beard: 'mustache', skin: '#c08a5c', fx: '#ff6a5a', c: { metal: '#6b5a4a', plume: '#8a1f2a', armor: '#35604a' } },
  skills: [
    ['爆雷擊', 'bolt', '擲出魔法鐵鎚，造成 {100/175/225/300} 傷害並暈眩 {1.25/1.5/1.75/2} 秒。', { x: { k: 'nuke', dmg: [100, 175, 225, 300], cc: { stun: [1.25, 1.5, 1.75, 2] }, fx: 'thunder' }, aim: U(480), cd: 16, el: 'thunder' }],
    ['橫掃千軍', 'passive', '普攻把 {30/45/60/75}% 傷害擴散給目標附近的敵人。', { pv: { cleave: [30, 45, 60, 75] } }],
    ['防守戰術', 'passive', '附近友軍防禦 +{2/3/4/5}。', { pv: { aura: { r: 400, armor: [2, 3, 4, 5] } } }],
    ['幻影分身', 'stealth', '創造 9 個分身並解除身上的法術效果；分身有本體 30% 攻擊力、受到 200% 傷害，持續 {15/25/35} 秒。', { x: { k: 'summon', self: true, n: 9, image: 0.3, taken: 2, dur: [15, 25, 35], cleanse: true, spread: 70, name: '魏延' }, aim: S(0), cd: 130, mp: [200, 250, 300] }],
  ],
});
